import { MijnRoute } from '../../../mijn-navigatie.model';

export const SELF_SERVICE_ECOMMERCE_PAYMENT: MijnRoute = {
    path: ':id',
    navigationEvent: 'toEcommerce',
    regex: /^\/zelf-regelen\/ecommerce\/[^/]+$/,
    webcomponent: 'mijn-ecommerce-payments-webcomponent',
    internalPath: ':id'
};
